class Category {
	constructor(benefitCategoryData = {}) {
		this.id = benefitCategoryData.id || null
		this.name = benefitCategoryData.name || ''
		this.description = benefitCategoryData.description || ''
	}
}

export default Category;